module.exports = __webpack_public_path__ + "static/media/mail.17f1bd55.svg";